import { render, staticRenderFns } from "./EmployeePageHeader.vue?vue&type=template&id=2ee1bfe1&"
import script from "./EmployeePageHeader.vue?vue&type=script&lang=js&"
export * from "./EmployeePageHeader.vue?vue&type=script&lang=js&"
import style0 from "./EmployeePageHeader.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports